import React, { useState } from 'react';
import { Comment, Header, Form, TextArea } from 'semantic-ui-react';
import orderBy from 'lodash/orderBy';
import AmsDateFormatters from '../../../utils/AmsDateFormatters';
import AmsAlert from '../../../utils/AmsAlert';
import { useDispatch } from 'react-redux';
import { reportConversationReplyAction } from '../../../actions/reportActions';

const InternalConversation = ({ newReport }) => {
  const [modalDetailsIndex, setModalDetailsIndex] = useState(-1);
  const [modalReplyIndex, setModalReplyIndex] = useState(-1);
  const [replyMessage, setReplyMessage] = useState('');
  const [showActivityInfoAlert, setShowActivityInfoAlert] = useState(false);
  const [activityInfoType, setActivityInfoType] = useState('info');
  const [activityInfoMessage, setActivityInfoMessage] = useState('');

  const dispatch = useDispatch();

  const handleReplyChange = e => {
    setReplyMessage(e.target.value);
  };

  const toggleDetails = index => {
    setModalDetailsIndex(prev => (prev === index ? -1 : index));
  };

  const setReplyMode = index => {
    setModalReplyIndex(index);
  };

  const cancelReply = () => {
    setModalDetailsIndex(-1);
    setModalReplyIndex(-1);
    setReplyMessage('');
  };

  const entityToChar = (str, elm) => {
    const el = document.createElement(elm);
    el.innerHTML = str;
    return el.value;
  };

  const handleReplySubmit = conversationId => {
    const input = { id: conversationId, message: replyMessage };
    dispatch(
      reportConversationReplyAction(
        input,
        result => {
          setReplyMessage('');
          setModalReplyIndex(-1);

          if (result instanceof Error) {
            setShowActivityInfoAlert(true);
            setActivityInfoType('error');
            setActivityInfoMessage(
              `'Error: ${result.response?.data?.message || 'unknown error'}`
            );
          } else {
            setShowActivityInfoAlert(true);
            setActivityInfoType('success');
            setActivityInfoMessage('You have replied to the conversation.');
          }
        },
        newReport.reviewID
      )
    );
  };

  const activityInfoAlert = () => (
    <AmsAlert
      show={showActivityInfoAlert}
      title=""
      type={activityInfoType}
      showConfirm
      confirmButtonText="Ok"
      confirmButtonColor={'#DD6B55'}
      text={activityInfoMessage}
      onConfirm={() => setShowActivityInfoAlert(false)}
    />
  );

  const { internalConversations } = newReport || {};

  return (
    <Comment.Group>
      <Header as="h3" dividing>
        Internal Shared Log
      </Header>

      {activityInfoAlert()}

      {internalConversations && internalConversations.length > 0
        ? orderBy(internalConversations, ['sharedDate'], ['desc']).map(
            (e, index) => {
              const assignedEmails = Array.isArray(e.assignedUsers)
                ? e.assignedUsers.map(u => u.email)
                : [];

              const filteredSharedWith =
                Array.isArray(e.sharedWithInfo) && e.sharedWithInfo.length > 0
                  ? e.assignedUsers?.length > 0
                    ? e.sharedWithInfo.filter(
                        u => !assignedEmails.includes(u.email)
                      )
                    : e.sharedWithInfo
                  : [];

              const sharedWith =
                filteredSharedWith.length > 0
                  ? filteredSharedWith.map(u => u.fullName).join(', ')
                  : null;
              return (
                <Comment key={index}>
                  <Comment.Content>
                    <Comment.Author as="span">{e.sharedBy}</Comment.Author>
                    <Comment.Metadata>
                      <div>
                        {AmsDateFormatters.formatUtcDateTime(e.sharedDate)}
                      </div>
                    </Comment.Metadata>
                    <a
                      href="#"
                      onClick={evt => {
                        evt.preventDefault();
                        toggleDetails(index);
                      }}
                    >
                      {modalDetailsIndex === index
                        ? '(Hide Details)'
                        : '(Show Details)'}
                    </a>

                    {modalDetailsIndex === index && (
                      <>
                        <Comment.Metadata
                          style={{ display: 'block', margin: '.5em 0 0 0' }}
                        >
                          <div>
                            Assigned To:{' '}
                            {Array.isArray(e.assignedUsers) &&
                            e.assignedUsers.length > 0
                              ? e.assignedUsers.map(u => u.fullName).join(', ')
                              : e.assigneeInfo?.fullName || 'N/A'}
                          </div>
                        </Comment.Metadata>
                        <Comment.Metadata
                          style={{ display: 'block', margin: '.5em 0 0 0' }}
                        >
                          <div>
                            Due Date:{' '}
                            {AmsDateFormatters.formatDate(e.expirationDate)}
                          </div>
                        </Comment.Metadata>
                        {sharedWith && (
                          <Comment.Metadata
                            style={{ display: 'block', margin: '.5em 0 0 0' }}
                          >
                            <div>Shared With: {sharedWith}</div>
                          </Comment.Metadata>
                        )}
                      </>
                    )}

                    <Comment.Text>{e.message}</Comment.Text>

                    {e.sharedGroup && (
                      <Comment.Actions>
                        <Comment.Action onClick={() => setReplyMode(index)}>
                          Reply
                        </Comment.Action>
                      </Comment.Actions>
                    )}
                  </Comment.Content>

                  {e.replies && e.replies.length > 0 && (
                    <Comment.Group>
                      {orderBy(e.replies, ['addedAt'], ['desc']).map(
                        (reply, rIndex) => (
                          <Comment key={rIndex}>
                            <Comment.Content>
                              <Comment.Author as="span">
                                {reply.addedBy.fullName}
                              </Comment.Author>
                              <Comment.Metadata>
                                <div>
                                  {AmsDateFormatters.formatUtcDateTime(
                                    reply.addedAt
                                  )}
                                </div>
                              </Comment.Metadata>
                              <Comment.Text>{reply.message}</Comment.Text>
                            </Comment.Content>
                          </Comment>
                        )
                      )}
                    </Comment.Group>
                  )}

                  {modalReplyIndex === index && (
                    <Form
                      reply
                      onSubmit={() => handleReplySubmit(e.conversationId)}
                    >
                      <TextArea
                        value={entityToChar(replyMessage, 'textarea')}
                        onChange={handleReplyChange}
                        rows={3}
                        style={{ height: '100px' }}
                      />
                      <Form.Group style={{ marginTop: '5px' }}>
                        <Form.Button
                          type="submit"
                          primary
                          content="Add Reply"
                        />
                        <Form.Button
                          onClick={cancelReply}
                          type="button"
                          content="Cancel"
                        />
                      </Form.Group>
                    </Form>
                  )}
                </Comment>
              );
            }
          )
        : 'No Conversations found.'}
    </Comment.Group>
  );
};

export default InternalConversation;
